import { ChatSchedule, ChatScheduleAction, ChatScheduleTypes, DateRange } from '../types';

export function requestAddSchedule(range: DateRange): ChatScheduleAction<DateRange> {
    return {
        type: ChatScheduleTypes.REQUEST_ADD_SCHEDULE,
        payload: range,
    };
}
export function requestUpdateSchedule(
    id: string,
    range: DateRange,
): ChatScheduleAction<{ range: DateRange; id: string }> {
    return {
        type: ChatScheduleTypes.REQUEST_UPDATE_SCHEDULE,
        payload: {
            range,
            id,
        },
    };
}

export function upsertSchedule(schedule: ChatSchedule): ChatScheduleAction<ChatSchedule> {
    return {
        type: ChatScheduleTypes.UPSERT_SCHEDULE,
        payload: schedule,
    };
}

export function requestGetSchedules(range: DateRange): ChatScheduleAction<DateRange> {
    return {
        type: ChatScheduleTypes.REQUEST_GET_SCHEDULES,
        payload: range,
    };
}
export function getSchedules(
    schedules: ChatSchedule[],
    range: DateRange,
): ChatScheduleAction<{ schedules: ChatSchedule[]; range: DateRange }> {
    return {
        type: ChatScheduleTypes.GET_SCHEDULES,
        payload: {
            schedules,
            range,
        },
    };
}

export function requestDeleteSchedule(id: string): ChatScheduleAction<string> {
    return {
        type: ChatScheduleTypes.REQUEST_DELETE_SCHEDULE,
        payload: id,
    };
}
export function deleteSchedule(id: string): ChatScheduleAction<string> {
    return {
        type: ChatScheduleTypes.DELETE_SCHEDULE,
        payload: id,
    };
}
export function scheduleErrorSaving(error: string) {
    return {
        type: ChatScheduleTypes.SCHEDULE_ERROR_SAVING,
        payload: { error },
    };
}

export function scheduleErrorLoading(error: string) {
    return {
        type: ChatScheduleTypes.SCHEDULE_ERROR_SAVING,
        payload: { error },
    };
}

export function clearScheduleError() {
    return {
        type: ChatScheduleTypes.CLEAR_SCHEDULE_ERROR,
    };
}
